var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1354 4.52456C11.0381 3.42656 9.57878 2.82122 8.02411 2.82056C4.81944 2.82056 2.21211 5.42656 2.21144 8.62989C2.21011 9.64922 2.47744 10.6512 2.98678 11.5346L2.16211 14.5452L5.24344 13.7372C6.09611 14.2012 7.05078 14.4446 8.02144 14.4446H8.02411C11.2274 14.4446 13.8348 11.8379 13.8361 8.63456C13.8368 7.08256 13.2328 5.62322 12.1354 4.52456Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73047 9.72329L9.00114 9.45462C9.2498 9.20795 9.64314 9.17662 9.9298 9.37795C10.2071 9.57262 10.4578 9.74729 10.6911 9.90995C11.0618 10.1673 11.1065 10.6953 10.7871 11.014L10.5478 11.2533",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 6.13587L5.66902 5.89653C5.98769 5.57787 6.51569 5.62253 6.77302 5.99253C6.93502 6.22587 7.10969 6.47653 7.30502 6.75387C7.50635 7.04053 7.47569 7.43387 7.22835 7.68253L6.95969 7.9532",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5465 11.2532C9.55918 12.2359 7.89984 11.4012 6.58984 10.0906",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59204 10.0927C5.28204 8.78199 4.44738 7.12332 5.43004 6.13599",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96094 7.95312C7.1736 8.28846 7.44627 8.62046 7.75427 8.92846L7.7556 8.92979C8.0636 9.23779 8.3956 9.51046 8.73094 9.72313",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.6a23921e7bc63d0fb8f7d635bc204893.svg";
export { ForwardRef as ReactComponent };